<aside
  class="sidebar"
  [class.collapsed]="collapsed"
  role="navigation"
  aria-label="Navegação principal"
>
  <div class="logo">
    <div class="logo-full">
      <img
        src="img/avalara-logo-1.png"
        alt="Vetor IT"
        class="logo-icon"
      />
      <span class="brand">
        Controle <span class="brand-accent">Bilhetagem</span>
      </span>
    </div>

    <div class="logo-compact">
      <img
        src="img/avalara-logo-1.png"
        alt="Vetor IT"
        class="logo-icon-compact"
      />
    </div>
  </div>

  <ng-template #submenuLink let-sub="sub">
    <a
      *ngIf="sub.routerLink && !sub.url"
      [routerLink]="sub.routerLink"
      [attr.id]="sub.id"
      routerLinkActive="active-sub"
      (click)="onSubmenuNavigate()"
    >
      <i *ngIf="sub.icon" [class]="sub.icon" aria-hidden="true"></i>
      <span>{{ sub.label }}</span>
    </a>

    <a
      *ngIf="sub.url && !sub.routerLink"
      [href]="sub.url"
      [attr.id]="sub.id"
      target="_blank"
      rel="noopener"
      (click)="onSubmenuNavigate()"
    >
      <i *ngIf="sub.icon" [class]="sub.icon" aria-hidden="true"></i>
      <span>{{ sub.label }}</span>
    </a>
  </ng-template>

  <ul class="nav">
    <li
      *ngFor="let item of items; trackBy: trackById"
      [class.flyout-open]="collapsed && isFlyoutOpen(item)"
    >
      <div
        class="nav-section"
        *ngIf="!item.items && !item.icon && !item.url && !item.routerLink"
      >
        {{ item.label }}
      </div>

      <ng-container *ngIf="hasChildren(item); else singleItem">
        <div
          class="nav-item-flyout-host"
          (mouseenter)="onNavItemHover(item)"
          (mouseleave)="onNavItemHoverEnd()"
        >
          <button
            type="button"
            class="nav-parent has-children"
            [attr.id]="item.id"
            (click)="toggleParent(item, $event)"
            [attr.aria-expanded]="collapsed ? isFlyoutOpen(item) : isExpandedSubmenuOpen(item)"
            [attr.aria-haspopup]="collapsed ? 'menu' : null"
            [attr.aria-label]="collapsed ? item.label : null"
            [attr.title]="collapsed ? item.label : null"
          >
            <i *ngIf="item.icon" [class]="item.icon" aria-hidden="true"></i>

            <span class="label">
              {{ item.label }}
            </span>

            <i class="pi pi-chevron-down ml-auto submenu-arrow" aria-hidden="true"></i>
          </button>

          <ul
            class="submenu"
            *ngIf="isExpandedSubmenuOpen(item)"
          >
            <li *ngFor="let sub of item.items; trackBy: trackById">
              <ng-container
                *ngTemplateOutlet="submenuLink; context: { sub: sub }"
              ></ng-container>
            </li>
          </ul>

          <div
            class="submenu-flyout-wrapper"
            *ngIf="isFlyoutOpen(item)"
            role="menu"
            [attr.aria-label]="item.label"
            (mouseenter)="onFlyoutHover()"
            (mouseleave)="onNavItemHoverEnd()"
          >
            <div class="submenu-flyout-panel">
              <div class="submenu-flyout-title">
                {{ item.label }}
              </div>

              <ul class="submenu-flyout">
                <li *ngFor="let sub of item.items; trackBy: trackById" role="none">
                  <ng-container
                    *ngTemplateOutlet="submenuLink; context: { sub: sub }"
                  ></ng-container>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #singleItem>
        <a
          *ngIf="item.routerLink"
          [routerLink]="item.routerLink"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [attr.id]="item.id"
          [attr.title]="collapsed ? item.label : null"
        >
          <i *ngIf="item.icon" [class]="item.icon" aria-hidden="true"></i>

          <span class="label">
            {{ item.label }}
          </span>

          <span
            class="badge"
            *ngIf="item.badge"
            [ngClass]="item.badgeStyleClass"
          >
            {{ item.badge }}
          </span>
        </a>

        <a
          *ngIf="!item.routerLink && item.url"
          [href]="item.url"
          target="_blank"
          rel="noopener"
          [attr.title]="collapsed ? item.label : null"
        >
          <i *ngIf="item.icon" [class]="item.icon" aria-hidden="true"></i>

          <span class="label">
            {{ item.label }}
          </span>
        </a>
      </ng-template>
    </li>
  </ul>
</aside>
